import { render, staticRenderFns } from "./event-conference-data-form.vue?vue&type=template&id=6daa1718&scoped=true"
import script from "./event-conference-data-form.vue?vue&type=script&lang=js"
export * from "./event-conference-data-form.vue?vue&type=script&lang=js"
import style0 from "./event-conference-data-form.vue?vue&type=style&index=0&id=6daa1718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa1718",
  null
  
)

export default component.exports